import InputError from './input-error';

export default InputError;